import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

export const getCategoryWithSubCategory = async (data) => {
  const url = baseUrl + `/getCategoryWithSubCategory`;
  try {
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
